import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Slider, { Settings } from 'react-slick';

import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import CheckoutAdditionalService from '../..';
import { useTheme, ThemeProvider } from '../../../theme';
import { ModalX } from '../../../BaseComponents';
import { getCapsuleHotel, getSegments } from '../../../Checkout/store/order/selectors';
import { getCalculatedCapsuleHotelPrice } from '../../../Checkout/store/orderPrice/selectors';
import { useIsCanModifyServices } from '../../hooks';
import { useOrderService } from '../hooks';
import VipServiceSelect from '../../../VipServiceSelect';
import { SafeHtml } from '@shared/ui';

const CapsuleHotel: React.FC = () => {
	const { CapsuleHotel: theme } = useTheme('CheckoutAdditionalService');
	const { t } = useTranslation('Checkout');

	const segments = useSelector(getSegments);
	const capsuleHotelServices = useSelector(getCapsuleHotel);
	const price = useSelector(getCalculatedCapsuleHotelPrice);

	// TODO: refactor this when php sends pictures
	const slides: string[] = [
		'https://icdn.lenta.ru/images/2019/12/29/16/20191229162041144/pwa_list_rect_1280_35b06e2bd3403fb2d4748e36b1e25189.png',
		'https://icdn.lenta.ru/images/2019/12/29/16/20191229162041144/pwa_list_rect_1280_35b06e2bd3403fb2d4748e36b1e25189.png',
		'https://icdn.lenta.ru/images/2019/12/29/16/20191229162041144/pwa_list_rect_1280_35b06e2bd3403fb2d4748e36b1e25189.png'
	];

	const {
		isSelected,
		selectedServices,
		onOpen,
		onClose,
		setOpened,
		onSaveHandler,
		passengers,
		opened,
		renderPassenger
	} = useOrderService(capsuleHotelServices, OrderAdditionalServiceGdsServiceServiceType.Vip);

	const isCanModifyServices = useIsCanModifyServices(capsuleHotelServices);

	if (capsuleHotelServices.length === 0) {
		return null;
	}

	const sliderOptions: Settings = {
		className: theme.slider,
		dotsClass: theme.dots,
		slidesToShow: 1,
		speed: 600,
		arrows: false,
		infinite: false,
		dots: true
	};

	return (
		<>
			<ThemeProvider
				value={{
					CheckoutAdditionalService: {
						CheckoutAdditionalService: {
							main: theme.main
						}
					}
				}}
			>
				<CheckoutAdditionalService
					header={t('Capsule hotel')}
					description={capsuleHotelServices[0].description}
					className={theme.capsuleHotel}
					priceFrom={price}
					priceTotal={price}
					isSelected={isSelected}
					addClick={onOpen}
					descriptionClassName={theme.descriptions}
					buttons={[
						{
							action: () => setOpened(true),
							text: isCanModifyServices ? t('Change') : t('More details')
						}
					]}
					addButtonText={!isCanModifyServices ? t('More details') : null}
				>
					{capsuleHotelServices[0].description}
				</CheckoutAdditionalService>
			</ThemeProvider>

			<ModalX size="medium" isOpen={opened} onClose={onClose} noPadding>
				<VipServiceSelect
					header={t('Capsule hotel')}
					headerClassName={theme.header}
					subheader={
						<>
							{slides.length > 0 && (
								<Slider {...sliderOptions}>
									{slides.map((image, index) => (
										<div className={theme.slide} key={index}>
											<img src={image} alt="" />
										</div>
									))}
								</Slider>
							)}

							{capsuleHotelServices[0].vipFullDescription && (
								<SafeHtml tag="div" html={capsuleHotelServices[0].vipFullDescription} />
							)}
						</>
					}
					passengers={passengers}
					services={capsuleHotelServices}
					segments={segments}
					selectedServices={selectedServices}
					type="checkbox"
					onSave={onSaveHandler}
					onClose={onClose}
					renderPassenger={renderPassenger}
					readOnly={!isCanModifyServices}
					showTotalPrice
				/>
			</ModalX>
		</>
	);
};

export default CapsuleHotel;
